import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WholeSyncablePriceFragment = { readonly __typename?: 'SyncablePrice', readonly id: string, readonly value: number, readonly priceListId: string, readonly itemId: string, readonly tariffId: string, readonly revenueDepartmentId: string, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly updatedAt: string, readonly updatedByUserId: string, readonly deleted: boolean } };

export type SyncPricePullQueryVariables = Types.Exact<{
  input: Types.PullPriceInput;
}>;


export type SyncPricePullQuery = { readonly __typename?: 'Query', readonly pullPrice: { readonly __typename?: 'PullPriceResult', readonly checkpoint?: { readonly __typename?: 'SyncableCheckpoint', readonly id: string, readonly updatedAt: string } | null, readonly documents: ReadonlyArray<{ readonly __typename?: 'SyncablePrice', readonly id: string, readonly value: number, readonly priceListId: string, readonly itemId: string, readonly tariffId: string, readonly revenueDepartmentId: string, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly updatedAt: string, readonly updatedByUserId: string, readonly deleted: boolean } }> } };

export const WholeSyncablePriceFragmentDoc = gql`
    fragment WholeSyncablePrice on SyncablePrice {
  id
  value
  priceListId
  itemId
  tariffId
  revenueDepartmentId
  meta {
    createdAt
    createdByUserId
    updatedAt
    updatedByUserId
    deleted
  }
}
    `;
export const SyncPricePullDocument = gql`
    query SyncPricePull($input: PullPriceInput!) {
  pullPrice(input: $input) {
    checkpoint {
      id
      updatedAt
    }
    documents {
      ...WholeSyncablePrice
    }
  }
}
    ${WholeSyncablePriceFragmentDoc}`;

/**
 * __useSyncPricePullQuery__
 *
 * To run a query within a React component, call `useSyncPricePullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSyncPricePullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncPricePullQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncPricePullQuery(baseOptions: Apollo.QueryHookOptions<SyncPricePullQuery, SyncPricePullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SyncPricePullQuery, SyncPricePullQueryVariables>(SyncPricePullDocument, options);
      }
export function useSyncPricePullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SyncPricePullQuery, SyncPricePullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SyncPricePullQuery, SyncPricePullQueryVariables>(SyncPricePullDocument, options);
        }
export type SyncPricePullQueryHookResult = ReturnType<typeof useSyncPricePullQuery>;
export type SyncPricePullLazyQueryHookResult = ReturnType<typeof useSyncPricePullLazyQuery>;
export type SyncPricePullQueryResult = Apollo.QueryResult<SyncPricePullQuery, SyncPricePullQueryVariables>;